(() => {
  // assets/scripts/questions.ts
  var links = document.querySelectorAll(".questions-nav a");
  links.forEach((link) => {
    link.addEventListener("click", (e) => {
      const id = link.getAttribute("href")?.slice(1);
      if (!id) return;
      const target = document.getElementById(id);
      if (!target) return;
      e.preventDefault();
      links.forEach((l) => l.classList.remove("is-active"));
      link.classList.add("is-active");
      window.scrollTo({
        top: target.offsetTop - 80,
        behavior: "smooth",
      });
    });
  });
})();
